<template>
  <div>
    <!-- 身份证后六位验证 -->
    <div v-if="tax && taxT" class="validateMail">
      <div class="mailBg">
        <el-image :src="mailBg" fit="scale-down" style="width: 100%; height: 100%"></el-image>
        <div class="mailFormBox">
          <div class="mailForm" style="display: flex">
            <div class="inputBox">
              <el-input v-model="value" size="large" placeholder="请输入密码进行验证" clearable @keyup.native.enter="submit"></el-input>
            </div>
            <el-button type="success" size="large" class="submit" @click="submit">查 看</el-button>
          </div>
          <p class="date">工资条发送于{{$route.query.time}}</p>
        </div>
      </div>
    </div>
    <!-- 查看详情 -->
    <div v-if="!tax" class="preview-demo">
      <div class="preview-content" style="position: relative">
        <div class="browser-main">
          <div class="salary">
            <div class="salary-title">{{wagesForm.wageMonth}} 工资明细</div>
            <div class="salary-info">
              <p class="salary-value">{{ getHighLightField.columnValue }}</p>
              <p class="salary-label" v-if="wagesForm.isBilingual=='31240001' || wagesForm.isBilingual=='31240003'">{{ getHighLightField.itemName }}</p>
              <p class="salary-label" v-if="wagesForm.isBilingual=='31240002' || wagesForm.isBilingual=='31240003'">
                {{ getHighLightField.itemEnName ? getHighLightField.itemEnName : (wagesForm.isBilingual=='31240002') ? getHighLightField.itemName : '' }}
              </p>
              <div v-if="wagesForm.downLoadSetting && wagesForm.downLoadSetting != '10520001'" @click="dowln" style="width: 27px; position: absolute; right: 20px; bottom: 10px;cursor: pointer">
                <el-image :src="mailBgDow" fit="scale-down" style="width: 100%; height: 100%"></el-image>
              </div>
            </div>
          </div>
          <el-alert type="warning" :closable="false" class="notice" v-if="wagesForm.isNotice == '10020001' && wagesForm.noticTips">
            <div slot="title">
              <i class="el-icon-chat-line-round"></i>
              <span class="noticeContent">{{wagesForm.noticTips}}</span>
            </div>
          </el-alert>
          <div class="settings">
            <div class="setting-item" v-for="(emp,index) in itemListsFilter" :key="emp.id">
              <h4 class="setting-title" v-if="wagesForm.isBilingual=='31240001'">{{ emp.name }}</h4>
              <h4 class="setting-title" v-if="wagesForm.isBilingual=='31240002'">{{ emp.enName == null || emp.enName == '' ? emp.name : emp.enName }}</h4>
              <h4 class="setting-title" v-if="wagesForm.isBilingual=='31240003'">{{ emp.name + ' / ' + emp.enName | repNull}}</h4>
              <div class="setting-info">
                <div class="setting-item-sub" :class="[{'setting-item-sub-border' : wagesForm.isBilingual == '31240003'},{'setting-long' : emp.seq == '1'}]" v-for="(element,itemIndex) in emp.payrollItemParam" :key="element.id">
                  <div class="setting-name">
                    <p v-if="wagesForm.isBilingual=='31240001' || wagesForm.isBilingual=='31240003'">
                      {{ element.showName ? element.showName : element.itemName }}
                      <el-popover
                        v-if="element.remarks"
                        placement="bottom"
                        width="80"
                        trigger="click"
                        :content="element.remarks">
                        <svg class="icon" aria-hidden="true" slot="reference" style="margin-left: 3px; color: #05cfa4">
                          <use xlink:href="#icon-tishi"></use>
                        </svg>
                      </el-popover>
                    </p>
                    <p v-if="wagesForm.isBilingual=='31240002' || wagesForm.isBilingual=='31240003'">
                      {{ element.showEnName ? element.showEnName : element.itemEnName ? (element.showEnName ? element.showEnName : element.itemEnName) : (wagesForm.isBilingual=='31240002') ? element.itemName : '' }}
                      <el-popover
                        v-if="element.remarks && wagesForm.isBilingual=='31240002'"
                        placement="bottom"
                        width="80"
                        trigger="click"
                        :content="element.remarks">
                        <svg class="icon" aria-hidden="true" slot="reference" style="margin-left: 3px; color: #05cfa4">
                          <use xlink:href="#icon-tishi"></use>
                        </svg>
                      </el-popover>
                    </p>
                  </div>
                  <div class="setting-value" v-if="isSetting"><p>{{element | repValue}}</p></div>
                  <div class="setting-value" v-else><p>{{element.columnValue}}</p></div>
                </div>
              </div>
            </div>
          </div>
          <!-- 暂时注掉，后续需要再放开 -->
          <!-- <el-alert type="warning" :closable="false" class="notice" v-if="wagesForm.isAutoConfirm == '10020001'">
            <div slot="title">
              <i class="el-icon-chat-line-round"></i>
              <span class="noticeContent">如果您对工资没有疑问，但未点击确认按钮，{{wagesForm.autoConfirmNum}}{{wagesForm.autoConfirmType | dictFilter(dicts)}}后，工资单将自动确认</span>
            </div>
          </el-alert>
          <div class="divButtonRigth" style="position: relative; left: 280px; width: 200px;">
            <el-button type="primary" v-if="wagesForm.isFeedback == '10020001'" @click="feedback"
            style="background: rgb(255, 255, 255); color: rgb(153, 153, 153); border-color: rgb(153, 153, 153)" >对工资有疑问</el-button>
            <el-button type="primary" style="width:100px" >确认无误</el-button>
          </div> -->
        </div>
<!--        <div style="position: fixed; right: calc(50% - 400px); top: 47px; width: 150px">-->
<!--          <el-image :src="mailBgT" fit="scale-down" style="width: 100%; height: 100%"></el-image>-->
<!--          <p style="color: rgb(102, 102, 102)">-->
<!--            微信扫描上方二维码，进入中智薪税云小程序，即可微信查收最新和历史工资单。-->
<!--          </p>-->
<!--        </div>-->
      </div>
      <el-dialog v-dialogDrag :close-on-click-modal="false" :close-on-press-escape="false" title="工资反馈"
      :visible.sync="visible" :before-close="beforeClosed">
        <el-form :model="feedData" ref="feedData" label-width="70px" size="small">
          <el-form-item label="工资反馈">
            <el-input type="textarea" v-model="feedData.content" :rows="6"
            placeholder="请输入工资反馈" clearable maxlength="1000" show-word-limit />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="confirm" size="small">保 存</el-button>
          <el-button @click="closeDialog(null)" size="small">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getSlaryInfo, downPayrollEncl, censorPayrollReq, checkEmpInfo} from '@/api/payroll/payroll'
import { downloadFile, formatFloat } from '@/util/util';

export default {
  name: "validateMail",
  data() {
    return {
      mailBg: require('@/assets/img/mailBg.jpg'),
      value: '',
      tax: true,
      taxT: false,
      itemLists: [],
      wagesForm: {},
      isSetting: true,
      mailBgT: require('@/assets/img/u36.png'),
      mailBgDow: require('@/assets/img/u29.png'),
      feedData: {content: ''},
      visible: false,
      xuehua: '',
      randStr: '',
      tablePk: ''
    }
  },
  created() {
    this.init()
  },
  filters:{
    repNull(val) {
      if (val.indexOf('null')) {
        return val.replaceAll("null",'');
      }
    },
    repValue(val) {
      if (val.valueType == '2') {
        let xx = val.columnValue ? val.columnValue : '0.00';
        let xxx = xx.split('.');
        if (xxx.length > 1) {
          if ( xxx[1].length == 1) {
            xx += '0';
          }
        } else if (xxx.length == 1) {
          xx += '.00'
        }
        return xx;
      } else {
        return val.columnValue ? val.columnValue : '--';
      }
    }
  },
  methods: {
    init() {
      if (!this.$route.query.xuehua || !this.$route.query.randStr || this.$route.query.randStr.length != 132) {
        this.$router.push({path: '/login'})
      }
      this.xuehua = this.$route.query.xuehua;
      this.randStr = this.$route.query.randStr;
      let param = {
        xuehua: this.xuehua,
        randStr: this.randStr,
      }
      censorPayrollReq(param).then(res => {
        this.taxT = res.data.data.res;
        this.tablePk = res.data.data.tablePk;
        // 校验参数
        if (this.taxT) {

        } else {
          // 不正确返回登录
          this.$router.push({path: '/login'})
        }
      })
    },
    submit() {
      let param = {
        inputVal: this.value,
        xuehua: this.xuehua,
        randStr: this.randStr,
      }
      checkEmpInfo(param).then(res => {
        if (res.data.data.tablePk) {
          this.tax = false;
          this.initSalaryInfo();
        } else {
          this.$message.error('证件号码错误！');
        }
      })
    },
    initSalaryInfo() {
      getSlaryInfo({tablePk: this.tablePk}).then((res) => {
        this.wagesForm = res.data.data;
        this.itemLists = this.wagesForm.payrollSets;
      });
    },
    dowln() {
      downPayrollEncl({id: this.$route.query.xuehua}).then(res => {
        downloadFile(res);
      })
      this.$message.success('下载中，请稍等!');
    },
    feedback() {
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    },
    confirm() {
      this.visible = false;
      this.$message.success('反馈成功!');
    },
    // beforeunloadHandler(e) {
    //   e = e || window.event
    //   if (e) {
    //     e.returnValue = '关闭提示！'
    //   }
    //   return '关闭提示';
    // }
  },
  computed: {
    ...mapGetters([
      'dicts',
    ]),
    itemListsFilter() {
      let itemLists = this.itemLists;
      if (!this.isSetting) {
        let arr = [];
        itemLists.forEach((emp,index) => {
          let params = {
            ...emp,
            payrollItemParam: []
          }
          emp.payrollItemParam.forEach((element,eleIndex) => {
            element.columnValue = element.result;
            let flag = element.isDisplayNull == "10020001" || (element.isDisplayNull == "10020002" && !!element.result && element.result != 0);
            if (flag) {
              params.payrollItemParam.push(element);
            }
          })
          if (params.payrollItemParam.length > 0) {
            arr.push(params);
          }
        })
        return arr;
      } else {
        let arr = [];
        itemLists.forEach((emp,index) => {
          let params = {
            ...emp,
            payrollItemParam: []
          }
          emp.payrollItemParam.forEach((element,eleIndex) => {
            let flag = element.isDisplayNull == "10020002" || (element.isDisplayNull == "10020001" && !!element.columnValue && element.columnValue != 0);
            // let flag = element.isDisplayNull == '10020002' ? (element.columnValue ? true : false) : true;
            if (flag) {
              params.payrollItemParam.push(element);
            }
          })
          if (params.payrollItemParam.length > 0) {
            arr.push(params);
          }
        })
        return arr;
      }
    },
    /**
     * 高亮显示选中值
     * 当高亮显示值为空时，展示为“-”
     * @returns {*|{}}
     */
    getHighLightField () {
      let highLightField = this.highLightFieldOptions.filter(item => {
        return item.id == this.wagesForm.highLightField
      })[0] || {};
      if (!this.isSetting) {
        highLightField.columnValue = highLightField.result;
      }
      highLightField.columnValue = highLightField.columnValue != '' && highLightField.columnValue != null && highLightField.columnValue != undefined ? highLightField.columnValue : '-';
      return highLightField;
    },
    // 高亮显示下拉框
    highLightFieldOptions () {
      let options = [];
      let itemLists = this.itemLists;
      itemLists.forEach(emp => {
        options = options.concat(emp.payrollItemParam);
      })
      return options;
    }
  },
  // mounted() {
  //   window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  // },
  // destroyed() {
  //   window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
  // }
}
</script>

<style lang="scss" scoped>
  .validateMail{
    position: relative;
    .mailBg {
      width: 1000px;
      height: 500px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, 25%);
    }
    .mailFormBox {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      padding-top: 210px;
      padding-left: 100px;
      box-sizing: border-box;
      .mailForm {
        display: flex;
        .inputBox {
          width: 270px;
          margin-right: 10px;
        }
        .submit {
          background-color: #67c23a;
          font-size: 15px;
          width: 90px;
        }
      }
      .date {
        color: rgb(204,204,204);
        font-size: 15px;
        margin-top: 125px;
      }
    }
  }

.preview-demo {
  margin: 0 auto;
  width: 500px;
  font-size: 12px;
  .preview-content {
    box-sizing: border-box;
    .browser-main {
      padding: 10px 10px 0 10px;
      box-sizing: border-box;
    }
    .salary {
      color: #666;
      background-color: rgba(242, 242, 242, 1);
      overflow: hidden;
      box-sizing: border-box;
      border-radius: 4px;
      .salary-title {
        padding: 10px 10px 0 10px;
        height: 16px;
        line-height: 16px;
      }
      .salary-info {
        position: relative;
        overflow: hidden;
        text-align: center;
        padding-top: 5%;
        padding-bottom: 5%;
        .salary-value {
          color: #333;
          font-size: 30px;
          height: 44px;
          line-height: 44px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
        }
      }
    }
    .settings {
      background-color: rgba(250, 250, 250, 1);
      border-radius: 0 0 30px 30px;
      overflow-y: auto;
      padding: 6px;
      box-sizing: border-box;
      .setting-item {
        margin-top: 6px;
        .setting-title {
          position: relative;
          line-height: 20px;
          color: #08245b;
          padding-left: 15px;
          margin-bottom: 6px;
        }
        .setting-title:before {
          content: "";
          display: block;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 5px;
          height: 18px;
          background-color: #08245b;
        }
        .setting-info {
          padding: 3px 0px 3px 6px;
          .setting-item-sub-border {
            border-bottom: 1px solid rgba(0,0,0,0.05);
          }
          .setting-item-sub {
            display: flex;
            align-items: center;
            justify-content: space-between;
            line-height: 18px;
            padding: 4px 0;
            color: #666;
            &:last-child {
              border: none;
            }
            .setting-name {
              width: calc(100% - 70px);
            }
            .setting-value {
              width: 150px;
              text-align: right;
            }
            &.setting-long {
              .setting-name {
                width: calc(100% - 140px);
              }
              .setting-value {
                width: 140px;
              }
            }
          }
        }
      }
    }
    .notice {
      margin: 10px 0;
      padding: 3px;
      .noticeContent {
        font-size: 12px;
        margin-left: 5px;
      }
    }
  }
}
</style>
